import { useAppSelector } from 'redux/hooks';
import { authSelectors } from 'redux/modules/Authorization';

export const useCurrentUser = () => useAppSelector(authSelectors.getUser);
